<template>
    <div>
        <div class="search-box">
            <p>学年：</p>
            <a-date-picker
                class="input-box"
                mode="year"
                format='YYYY'
                v-model="year" 
                :open='yearShowOne' 
                @openChange="openChangeOne"
                @panelChange="panelChangeOne">
                <a-input  v-model="searchFrom.schoolYear"/>
            </a-date-picker>
            <a-button type="primary" icon="search" @click="infoSearch">查询</a-button>

        </div>
        <div class="info-box">
            <div class="info-title">
                <h3>个人信息</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="input-box" >
                    <p>教师编号：</p>
                    <a-input class="input" v-model="info.teacherId" disabled />
                </div>
                <div class="input-box">
                    <p>教学名称：</p>
                    <a-input class="input" v-model="info.teacherName" disabled />
                </div>
                <div class="input-box">
                    <p>学年：</p>
                    <a-input class="input" v-model="info.schoolYear" disabled />
                </div>
                <!-- <div class="input-box">
                    <p>学院编码：</p>
                    <a-input class="input" v-model="info.orgCode" disabled />
                </div> -->
                <div class="input-box">
                    <p>学院名称：</p>
                    <a-input class="input" v-model="info.orgName" disabled />
                </div>
                <!-- <div class="input-box">
                    <p>职称编码：</p>
                    <a-input class="input" :value="info.technicalTitleCode" disabled />
                </div> -->
                <div class="input-box">
                    <p>职称名称：</p>
                    <a-input class="input" v-model="info.technicalTitleName" disabled />
                </div>
                <div class="input-box">
                    <p class="p2">全日制中文授课教学分：</p>
                    <a-input class="input" v-model="info.fullTimeCredit" disabled />
                </div>
                <div class="input-box">
                    <p>全英文授课教学分：</p>
                    <a-input class="input" v-model="info.allEnglishCredit" disabled />
                </div>
                <div class="input-box">
                    <p>研究生课程-总分值：</p>
                    <a-input class="input" v-model="info.totalCredit" disabled />
                </div>
                <div class="input-box">
                    <p>非全日制授课课时分：</p>
                    <a-input class="input" v-model="info.noFullTimeCredit" disabled/>
                </div>
                <div class="input-box input-box-center">
                    <p class="p3">研究生课程教学教分汇总-备注：</p>
                    <a-input class="input" v-model="info.remark" disabled/>
                </div>
            
            </div>
        </div>
        <div class="info-box">
            <div class="info-title">
                <h3>研究生课程教学工作量</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="input-box input-box-center">
                    <p></p>
                    <a-table :columns="kcjxColumns" :data-source="info.teachingWorkList" class="input" :pagination="{hideOnSinglePage:true}" bordered>
                    </a-table>
                </div>
            </div>
        </div>
        <div class="info-box">
            <div class="info-title">
                <h3>指导研究生工作量</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="input-box input-box-center">
                    <p></p>
                    <a-table :columns="zdyjsColumns" :data-source="info.guideGraduateWorkList" class="input" :pagination="{hideOnSinglePage:true}" bordered>
                    </a-table>
                </div>
            </div>
        </div>
        <div class="info-box">
            <div class="info-title">
                <h3>指导研究生分值汇总（设置封顶线）</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="input-box" >
                    <p>博士研究生：</p>
                    <a-input class="input" v-model="info.guideGraduateWorkSum.doctorCredit" disabled />
                </div>
                <div class="input-box" >
                    <p>学术型硕士研究生：</p>
                    <a-input class="input" v-model="info.guideGraduateWorkSum.academicMasterCredit" disabled />
                </div>
                <div class="input-box" >
                    <p>设置封顶后分值：</p>
                    <a-input class="input" v-model="info.guideGraduateWorkSum.upLimit" disabled />
                </div>
                <div class="input-box" >
                    <p>专业型硕士研究生：</p>
                    <a-input class="input" v-model="info.guideGraduateWorkSum.professionalGraduateCredit" disabled />
                </div>
                <div class="input-box" >
                    <p>质量系数：</p>
                    <a-input class="input" v-model="info.guideGraduateWorkSum.ratio" disabled />
                </div>
                <div class="input-box" >
                    <p>合计：</p>
                    <a-input class="input" v-model="info.guideGraduateWorkSum.total" disabled />
                </div>

            </div>
        </div>
        <div class="info-box">
            <div class="info-title">
                <h3>指导研究生分值</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="input-box" >
                    <p>留学生：</p>
                    <a-input class="input" v-model="info.guideGraduateWorkInternational.international" disabled />
                </div>
                <div class="input-box" >
                    <p>硕士（非全日制）：</p>
                    <a-input class="input" v-model="info.guideGraduateWorkInternational.masterCnt" disabled />
                </div>
                <div class="input-box" >
                    <p>备注（毕业人数）：</p>
                    <a-input class="input" v-model="info.guideGraduateWorkInternational.remark" disabled />
                </div>
            </div>
        </div>
        <!-- <div class="btn-box">
            <a-button @click="$router.go(-1)">取消</a-button>
        </div> -->
    </div>
</template>
<script>
    import { info } from '@/baseAPI/master/report'
    import { getSchoolYear } from '@/baseAPI/util'
    
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                type:'',
                info:{},
                year:'',
                yearShowOne:false,
                searchFrom:{
                    size: '',
                    current: '',
                    teacherName:'',
                    semester:'',
                    schoolYear:'',
                    departmentCode:''
                },
                permissions:[],
                kcjxColumns:[
                    {
                            title: '序号',
                            align:'center',
                            dataIndex:'index'
                        },
                        {
                            title: '课程及班级名',
                            dataIndex: 'className',
                            align:'center',
                        },
                        {
                            title: '选课人数',
                            dataIndex: 'studentNumber',
                            align:'center',
                        },
                        {
                            title: '课时',
                            dataIndex: 'courseHours',
                            align:'center',
                        },
                        {
                            title: '课程学分',
                            dataIndex: 'credit',
                            align:'center',
                        },
                        {
                            title: '全英文课程系数',
                            dataIndex: 'fullEnglishCoefficient',
                            align:'center',
                        },
                        {
                            title: '课程质量系数',
                            dataIndex: 'courseQualityCoefficient',
                            align:'center',
                        },
                        {
                            title: '研究生课程教学教分',
                            dataIndex: 'totalCredit',
                            align:'center',
                        },
                        {
                            title: '班级规模系数',
                            dataIndex: 'classSizeCoefficient',
                            align:'center',
                        },
                ],
                zdyjsColumns:[
                    {
                            title: '学位类别',
                            align:'center',
                            dataIndex:'typeCode'
                        },
                        {
                            title: '学生类型',
                            dataIndex: 'degreeCategory',
                            align:'center',
                        },
                        {
                            title: '学年-4年级',
                            dataIndex: 'year1',
                            align:'center',
                        },
                        {
                            title: '学年-3年级',
                            dataIndex: 'year2',
                            align:'center',
                        },
                        {
                            title: '学年-2年级',
                            dataIndex: 'year3',
                            align:'center',
                        },
                        {
                            title: '学年-1年级',
                            dataIndex: 'year4',
                            align:'center',
                        },
                        {
                            title: '核定分值',
                            dataIndex: 'credit',
                            align:'center',
                        },
                        {
                            title: '备注',
                            dataIndex: 'remark',
                            align:'center',
                        }
                ],
            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            this.year=getSchoolYear()+''
            this.searchFrom.schoolYear=getSchoolYear()+'-'+(getSchoolYear()+1)
            info(this.$store.state.user.userId,this.searchFrom.schoolYear).then(res=>{
                this.info=res.data;
            })
            

        },
        methods:{
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.year=this.getTimeStr(value._d,'yyyy')
                this.searchFrom.schoolYear=this.year+'-'+(this.year-0+1);
                this.yearShowOne = false;
            },
            infoSearch(){
                info(this.$store.state.user.userId,this.searchFrom.schoolYear).then(res=>{
                    this.info=res.data;
                })
            }
            
        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .info-main .input-box-center{
        width: 99%;
    }
    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box .p2{
        width: 12rem;
        text-align: right;
    }
    .info-main .input-box .p3{
        width: 20rem;
        text-align: right;
    }
    .info-main .input-box .input{
        width: calc(100% - 10rem);
    }

    .info-main .input-box .answer-input{
        width: calc(100% - 10rem);
        border-color:red;
    }

    .info-main .input-box .tips{
        width: calc(100% - 11rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .action-btn{
        background-color: #1890ff;
        color: #fff;
        line-height: 32px;
        padding: 0 15px;
        height: 32px;
        border-radius: 4px;
    }

    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 10px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 10rem;
    }
</style>
